import { render, staticRenderFns } from "./StatoWorkflow.vue?vue&type=template&id=48f2ec7a"
import script from "./StatoWorkflow.vue?vue&type=script&lang=ts"
export * from "./StatoWorkflow.vue?vue&type=script&lang=ts"
import style0 from "./StatoWorkflow.vue?vue&type=style&index=0&id=48f2ec7a&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48f2ec7a')) {
      api.createRecord('48f2ec7a', component.options)
    } else {
      api.reload('48f2ec7a', component.options)
    }
    module.hot.accept("./StatoWorkflow.vue?vue&type=template&id=48f2ec7a", function () {
      api.rerender('48f2ec7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/StatoWorkflow.vue"
export default component.exports